import React from 'react'
import TextField, {TextFieldProps} from '@mui/material/TextField'
import styled from 'styled-components'
import textfieldStyles from './textfield.styles'

export type ApTextBoxProps = TextFieldProps & {
  ap_display?: 'none'
  multiline?: boolean
}

const apAtomName = {ap_atom_name: 'textfieldAtom'}

const TextfieldAtom = styled((props: ApTextBoxProps) => {
  return <TextField {...apAtomName} inputProps={{title: ''}} {...props} />
})`
  ${textfieldStyles}
`

TextfieldAtom.defaultProps = {
  variant: 'filled'
}

export default TextfieldAtom
